export default __webpack_public_path__ + "static/media/curved1.af81cb53.jpg";